//以旧换新管理相关 api
import request from "@/utils/request";
const baseService = "autoapp-default-server-recovery";
//网点旧机库存模块 start
/**
 * @function  网点旧机库存模块-获取库存列表
 * @property {object}  params - 请求参数.
 * @property {string}  params.outletsNo - 网点编码
 * @returns {Promise<object>}
 */
export function getOldMachineRepertoryList(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/getOldMachineRepertoryByOutletsNo`,
    method: "post",
    data
  });
}

export function getOldMachineRepertoryDetail(recycleNo) {
  return request({
    url: `${baseService}/api/business/recycle/getDetail/${recycleNo}`,
    method: "post",
  });
}

/**
 * @function  网点旧机库存模块-创建回收单
 * @property {object}  data - 请求参数.
 * @property {string}  data.appointDate - 预约回收日期 yyyy-mm-dd
 * @property {string}  data.carrierNo - 承运商
 * @property {string}  data.recoveryWorker - 回收师傅
 * @property {string}  data.recoveryWorkerName - 回收师傅名称
 * @property {string}  data.networkNo - 网点编码
 * @property {string}  data.detailAddress - 回收地址
 * @property {string}  data.recoveryNum - 回收数量
 * @property {string}  data.estimateVolume - 预估方数
 * @property {string}  data.estimateWeight - 预估重量
 * @property {string}  data.warehouseNo - 旧机柜归集仓库
 * @property {string}  data.warehouseName - 旧机柜归集仓库名称
 * @property {string}  data.wmsWarehouse - 是否 wms 仓库
 * @property {Array}  data.dto - 旧机库存明细
 * @returns {Promise<object>}
 */

export function saveRecoveryApply(data) {
  return request({
    url: `${baseService}/api/business/recycle/assign`,
    method: "post",
    data
  });
}

/**
 * @function  网点旧机库存模块-获取回收师傅列表
 * @property {object}  params - 请求参数.
 * @property {string}  params.carrierNo - 承运商编码
 * @returns {Promise<object>}
 */

export function getEngineerList(carrierNo) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/findEngineerByOrgId/${carrierNo}`,
    method: "post"
  });
}


export function findOldMachineRecoveryList(data) {
  return request({
    url: `${baseService}/api/business/recycle/pageCondition`,
    method: "post",
    data
  });
}
/**
 * @function  旧机回收订单模块-获取回收订单详情
 * @property {object}  orderNo - 回收单 id.
 * @returns {Promise<object>}
 */


export function getRecoveryOrderByOrderNo(recycleNo) {
  return request({
    url: `${baseService}/api/business/recycle/getDetail/${recycleNo}`,
    method: "post"
  });
}
/**
 * @function  旧机回收订单模块-车辆信息维护
 * @property {object}  params -入参对象
 * @property {object}  params.operateType -2 车辆信息维护
 * @property {object}  params.driverName -司机姓名
 * @property {object}  params.driverTel - 电话
 * @property {object}  params.vehicleLicenseNo - 车辆牌号
 * @returns {Promise<object>}
 */
export function operateCarInfo(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/operateRecoveryApply`,
    method: "put",
    data
  });
}

/**
 * @function  旧机回收订单模块-改派
 * @property {object}  data -入参对象
 * @property {object}  data.operateType - 1 改派
 * @property {object}  data.appointDate -预约时间 yyyy-mm-dd
 * @property {object}  data.carrierNo - 承运商
 * @property {object}  data.recoveryWorker - 回收师傅
 * @property {string}  data.recoveryWorkerName - 回收师傅名称
 * @returns {Promise<object>}
 */
export function changeOrder(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/operateRecoveryApply`,
    method: "put",
    data
  });
}

/**
 * @function  商用旧机回收订单模块-取消回收单
 * @property {string}  recycleNo -入参
 * @returns {Promise<object>}
 */


export function cancelOrder(recycleNo) {
  return request({
    url: `${baseService}/api/business/recycle/cancelRecycle/${recycleNo}`,
    method: "get"
  });
}


/**
 * @function 获取承运商列表
 * @returns {Promise<object>}
 */
export function getPartner() {
  return request({
    url: `${baseService}/api/oldMachineRecovery/findPartnerManagement`,
    method: "get"
  });
}
/**
 * @function 获取归集仓列表
 * @returns {Promise<object>}
 */
export function getWarehouseList() {
  return request({
    url: `${baseService}/api/oldMachineRecovery/findWarehouse`,
    method: "get"
  });
}

/**
 * @function 获取销司列表
 * @returns {Promise<object>}
 */
export function getRegion() {
  return request({
    url: `${baseService}/api/oldMachineRecovery/queryRegion`,
    method: "post",
    data: {
      serviceType:['售后']
    }
  });
}
//旧机查询模块end

//承运商管理模块 start
/**
 * @function  承运商管理列表
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function getPartnerList(data) {
  return request({
    url: `${baseService}/api/business/partnerManagementBond/pageJdPartnerShip`,
    method: "post",
    data
  });
}
/**
 * @function  添加承运商-保存承运商保证金
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function savePartnership(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/savePartnership`,
    method: "post",
    data
  });
}

/**
 * @function  移除承运商
 * @property {object}  partnershipId - 请求参数.
 * @returns {Promise<object>}
 */
export function removePartnership(partnershipId) {
  return request({
    url: `${baseService}/api/partnerManagementBond/deleteByPartnershipId/${partnershipId}`,
    method: "delete"
  });
}

/**
 * @function  对应的保证金管理列表查询
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function findBondSerialByPartnershipId(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/findBondSerialByPartnershipId`,
    method: "post",
    data
  });
}

/**
 * @function  保证金缴纳/扣除
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function operatePartnerBond(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/bondOperateByPartnershipId`,
    method: "post",
    data
  });
}

/**
 * @function  承运商区域分配列表查询
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function getPartnerRegionList(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/findPartnerRegionAllocate`,
    method: "post",
    data
  });
}

/**
 * @function  承运商分配
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function savePartnerAllocateRegion(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/savePartnerAllocateRegion`,
    method: "post",
    data
  });
}

/**
 * @function  获取省份
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function findAllProvince(data) {
  return request({
    url: `${baseService}/api/partnerManagementBond/findAllProvince`,
    method: "post",
    data
  });
}
/**
 * @function  获取城市
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function findAllCity(provinceCode) {
  return request({
    url: `${baseService}/api/partnerManagementBond/findAllCity/${provinceCode}`,
    method: "post"
  });
}

/**
 * @function  获取区域
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function findAllCounty(cityCode) {
  return request({
    url: `${baseService}/api/partnerManagementBond/findAllCounty/${cityCode}`,
    method: "post"
  });
}


export function getCityLevelEnum(cityCode) {
  return request({
    url: `${baseService}/api/common/getCityLevelEnum`,
    method: "get"
  });
}

/**
 * @function 获取(未分配保证金的)承运商列表
 * @returns {Promise<object>}
 */
export function getPartnerByBond() {
  return request({
    url: `${baseService}/api/partnerManagementBond/findPartnerManagement`,
    method: "post"
  });
}


/**
 * @function 获取(已分配保证金的)承运商列表
 * @returns {Promise<object>}
 */
export function getPartnerManagementBond() {
  return request({
    url: `${baseService}/api/partnerManagementBond/getPartnerManagementBond`,
    method: "post"
  });
}


/**
 * @function 渠道类型
 * @returns {Promise<object>}
 */
export function salePlatformMap() {
  return request({
    url: `${baseService}/api/common/getSalePlatformMap`,
    method: "get",
  });
}


/**
 * @function 旧机状态
 * @returns {Promise<object>}
 */
export function getAppraisalNodeEnumsMap() {
  return request({
    url: `${baseService}/api/common/getAppraisalNodeEnumsMap`,
    method: "get",
  });
}

/**
 * @function 编辑回收单图片信息
 * @returns {Promise<object>}
 */
export function updateOldMachineRecovery({recycleNo,fileId,annexType}) {
  return request({
    url: `${baseService}/api/business/recycle/updateFile?recycleNo=${recycleNo}&&fileId=${fileId}&&annexType=${annexType}`,
    method: "get",

  });
}

/**
 * @function 旧机查询-结算单-导出
 * @returns {Promise<object>}
 */
export function exportSettlementList(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/exportSettlementList`,
    method: "post",
    data
  });
}

/**
 * @function 旧机查询-结算单-数据查询
 * @returns {Promise<object>}
 */
export function downSettlementList(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/downSettlementList`,
    method: "post",
    data
  });
}

/**
 * @function 旧机查询-结算单-明细查询
 * @returns {Promise<object>}
 */
export function settlementExportDetail(data) {
  return request({
    url: `${baseService}/api/oldMachineRecovery/settlementExportDetail`,
    method: "post",
    data
  });
}


/**
 * @function 城市等级看板-城市等级看板
 * @returns {Promise<object>}
 */
export function pageCondition(data) {
  return request({
    url: `${baseService}/api/city/pageCondition`,
    method: "post",
    data
  });
}






//承运商管理模块 end

//商用相关 -start todo全部都需要修改 入参
/**
 * @function  旧机查询模块-旧机详情
 * @property {object}  params - 请求参数.
 * @returns {Promise<object>}
 */
export function getOldMachineDetail(projectDetailNo) {
  return request({
    url: `${baseService}/api/business/project/getDetail/${projectDetailNo}`,
    method: "get",
  });
}


/**
 * @function 旧机结算（单个）
 * @returns {Promise<object>}
 */
export function settlementOrder(id) {
  return request({
    url: `${baseService}/api/business/project/settle/${id}`,
    method: "get",
  });
}

/**
 * @function 再生资源确认入库(单个)
 * @returns {Promise<object>}
 */
export function storageOrder(id) {
  return request({
    url: `${baseService}/api/business/project/warehousing/${id}`,
    method: "get",

  });
}


//获取所有商用枚举类型

export function dictEnumListAll(data) {
  return request({
    url: `${baseService}/api/common/dictEnum/listAll`,
    method: "post",
    data
  });
}




/**
 * @function  商用模块-旧机查询列表
 * @property {object}  params - 请求参数.
 * @returns {Promise<object>}
 */
export function getOldMachineList(data) {
  return request({
    url: `${baseService}/api/business/project/pageCondition`,
    method: "post",
    data
  });
}

//商用旧机品类
export function getCOMType() {
  return request({
    url: `${baseService}/api/business/category/listByCondition`,
    method: "get",
  });
}

//获取商用承运商列表
export function getCarrierList(data) {
  return request({
    url: `${baseService}/api/business/partnerManagementBond/pageJdPartnerShip`,
    method: "post",
    data
  });
}


export function updateLoadReportPriceFile(projectNo,reportPriceUrl) {
  return request({
    url: `${baseService}/api/business/project/updateLoadReportPriceFile?projectNo=${projectNo}&reportPriceUrl=${reportPriceUrl}`,
    method: "get",
  });
}

export function getSourceOrigin(data) {
  return request({
    url: `${baseService}/api/deSensitization/getSource`,
    method: "post",
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/COldForNew.js